import api from '@api'

export function getContractTypeApi(archived = false) {
  return api
    .post(
      `/contracttype/search/byqual`,
      {},
      {
        params: {
          ...(archived ? { archived: true } : {}),
          offset: 0,
          size: 1000,
        },
        notify: false,
      }
    )
    .then((data) => {
      return (data.objectList || []).map((c) => ({
        key: c.id,
        text: c.name,
        archived: c.removed,
      }))
    })
}
